import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios';
import env from '@/helpers/env';
import './assets/tailwind.css'

const axiosInstance = axios.create({
  baseURL: env.base_url,
});


Vue.config.productionTip = false
Vue.prototype.$axios = axiosInstance;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
